// =========================
// Constants
// =========================

const adminAjaxUrl = '/wp-admin/admin-ajax.php';

/* Helpers */

function getScopedNavigation(container, fallbackParent = null) {
  const scope = fallbackParent || container;

  return {
    nextEl: scope ? scope.querySelector('.swiper-arrow-next') : null,
    prevEl: scope ? scope.querySelector('.swiper-arrow-prev') : null,
  };
}

/* Мобильное меню */

function initMobileMenu() {
  const dialog = document.getElementById('mobile-menus');
  const burger = document.querySelector('.header__burger');

  if (!dialog || !burger) return;

  const closeBtn = dialog.querySelector('.close-btn');
  const menuLinks = dialog.querySelectorAll('.mobile__menus__items a');

  function openDialog() {
    dialog.showModal();

    dialog.animate(
      [
        { transform: 'translateX(-100%)', opacity: 0 },
        { transform: 'translateX(0)', opacity: 1 }
      ],
      {
        duration: 400,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );
  }

  function closeDialogWithAnimation() {
    const anim = dialog.animate(
      [
        { transform: 'translateX(0)', opacity: 1 },
        { transform: 'translateX(-100%)', opacity: 0 }
      ],
      {
        duration: 300,
        easing: 'ease-in',
        fill: 'forwards'
      }
    );

    anim.onfinish = () => {
      dialog.close();
    };
  }

  burger.addEventListener('click', openDialog);

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDialogWithAnimation);
  }

  menuLinks.forEach(link => {
    link.addEventListener('click', closeDialogWithAnimation);
  });
}

/* Модальное окно с контактами */

function initContactsModal() {
  const contactsDialog = document.getElementById('contacts-modal');
  if (!contactsDialog) return;

  const contactsOpenBtns = document.querySelectorAll('[data-dialog="contacts"]');
  const contactsCloseBtn = contactsDialog.querySelector('.close-btn');

  if (!contactsOpenBtns.length) return;

  function openContactsDialog() {
    contactsDialog.showModal();

    contactsDialog.animate(
      [
        { bottom: '-64px', opacity: 0 },
        { bottom: '0px', opacity: 1 }
      ],
      {
        duration: 300,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );
  }

  function closeContactsDialog() {
    const anim = contactsDialog.animate(
      [
        { bottom: '0px', opacity: 1 },
        { bottom: '-64px', opacity: 0 }
      ],
      {
        duration: 200,
        easing: 'ease-in',
        fill: 'forwards'
      }
    );

    anim.onfinish = () => contactsDialog.close();
  }

  contactsOpenBtns.forEach(btn => {
    btn.addEventListener('click', openContactsDialog);
  });

  if (contactsCloseBtn) {
    contactsCloseBtn.addEventListener('click', closeContactsDialog);
  }
}

/* Модальное окно с формой обратной связи */

function initCallbackModal() {
  const callbackDialog = document.getElementById('callback');
  if (!callbackDialog) return;

  const callbackOpenBtns = document.querySelectorAll('[data-dialog="callback"]');
  const callbackCloseBtn = callbackDialog.querySelector('.close-btn');

  if (!callbackOpenBtns.length) return;

  function openCallbackDialog() {
    callbackDialog.showModal();

    callbackDialog.animate(
      [
        { bottom: '-64px', opacity: 0 },
        { bottom: '0px', opacity: 1 }
      ],
      {
        duration: 300,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );
  }

  function closeCallbackDialog() {
    const anim = callbackDialog.animate(
      [
        { bottom: '0px', opacity: 1 },
        { bottom: '-64px', opacity: 0 }
      ],
      {
        duration: 200,
        easing: 'ease-in',
        fill: 'forwards'
      }
    );

    anim.onfinish = () => callbackDialog.close();
  }

  callbackOpenBtns.forEach(btn => {
    btn.addEventListener('click', openCallbackDialog);
  });

  if (callbackCloseBtn) {
    callbackCloseBtn.addEventListener('click', closeCallbackDialog);
  }
}

/* Модальное окно с преподавателями */

function initTeacherPopup() {
  const popup = document.querySelector('#teacher-popup');
  const buttons = document.querySelectorAll('.js-teacher-popup-open');

  if (!popup || !buttons.length) return;

  const closeBtn = popup.querySelector('.teacher-popup__close');
  const image = popup.querySelector('.teacher-popup__image img');
  const name = popup.querySelector('.teacher-popup__name');
  const description = popup.querySelector('.teacher-popup__description');

  let isAnimating = false;

  function openTeacherPopup() {
    if (isAnimating || popup.open) return;

    isAnimating = true;
    popup.showModal();

    const animation = popup.animate(
      [
        { transform: 'translateX(100%)', opacity: 0 },
        { transform: 'translateX(0)', opacity: 1 }
      ],
      {
        duration: 400,
        easing: 'ease',
        fill: 'forwards'
      }
    );

    animation.onfinish = () => {
      isAnimating = false;
    };
  }

  function closeTeacherPopup() {
    if (isAnimating || !popup.open) return;

    isAnimating = true;

    const animation = popup.animate(
      [
        { transform: 'translateX(0)', opacity: 1 },
        { transform: 'translateX(100%)', opacity: 0 }
      ],
      {
        duration: 400,
        easing: 'ease',
        fill: 'forwards'
      }
    );

    animation.onfinish = () => {
      popup.close();
      popup.style.transform = '';
      popup.style.opacity = '';
      isAnimating = false;
    };
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const teacherImage = button.dataset.image || '';
      const teacherName = button.dataset.name || '';
      const teacherDescription = button.dataset.description || '';

      image.src = teacherImage;
      image.alt = teacherName;

      name.textContent = teacherName;
      description.innerHTML = teacherDescription;

      openTeacherPopup();
    });
  });

  closeBtn.addEventListener('click', closeTeacherPopup);

  popup.addEventListener('click', (event) => {
    if (event.target === popup) {
      closeTeacherPopup();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.open) {
      event.preventDefault();
      closeTeacherPopup();
    }
  });
}

/* Баннер куки */

function initCookieBanner() {
  const cookieBanner = document.getElementById('cookie-banner');
  if (!cookieBanner) return;

  const okButton = cookieBanner.querySelector('.cookie-banner__btn');
  if (!okButton) return;

  const storageKey = 'cookieBannerAccepted';

  if (localStorage.getItem(storageKey) === 'true') {
    return;
  }

  cookieBanner.show();

  cookieBanner.animate(
    [
      { opacity: 0, transform: 'translateY(20px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ],
    {
      duration: 300,
      easing: 'ease-out',
      fill: 'forwards'
    }
  );

  okButton.addEventListener('click', () => {
    localStorage.setItem(storageKey, 'true');

    const anim = cookieBanner.animate(
      [
        { opacity: 1, transform: 'translateY(0)' },
        { opacity: 0, transform: 'translateY(20px)' }
      ],
      {
        duration: 200,
        easing: 'ease-in',
        fill: 'forwards'
      }
    );

    anim.onfinish = () => {
      cookieBanner.close();
    };
  });
}

/* Инициализируем всё */

document.addEventListener('DOMContentLoaded', function () {
  initMobileMenu();
  initContactsModal();
  initCallbackModal();
  initTeacherPopup();
  initCookieBanner();
});